function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../dialog';

require('./picviewer.less');

var picViewerPrefixCls = 'picviewer';

var PicViewer = /*#__PURE__*/function (_Component) {
  _inherits(PicViewer, _Component);

  var _super = _createSuper(PicViewer);

  function PicViewer() {
    var _this;

    _classCallCheck(this, PicViewer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      console.log('[PicViewer][handleClose]');
      var closeCallback = _this.props.closeCallback;
      if (closeCallback) closeCallback();
    });

    _defineProperty(_assertThisInitialized(_this), "handleImage", function (event) {
      console.log('[PicViewer][handleImage]');
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    });

    return _this;
  }

  _createClass(PicViewer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          renderInline = _this$props.renderInline;
      var visible = Boolean(image);
      return /*#__PURE__*/React.createElement(Dialog, {
        visible: visible,
        handleClose: this.handleClose,
        title: "",
        confirmText: "",
        cancelText: "",
        className: "dialog-".concat(picViewerPrefixCls),
        renderInline: renderInline
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(picViewerPrefixCls)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(picViewerPrefixCls, "-picwrap"),
        onClick: this.handleClose.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        className: "".concat(picViewerPrefixCls, "-img"),
        src: image,
        alt: "",
        onClick: this.handleImage
      }))));
    }
  }]);

  return PicViewer;
}(Component);

_defineProperty(PicViewer, "propTypes", {
  image: PropTypes.string,
  closeCallback: PropTypes.func,
  renderInline: PropTypes.bool
});

_defineProperty(PicViewer, "defaultProps", {
  image: '',
  closeCallback: null,
  renderInline: true
});

export default PicViewer;